import { DatePicker } from "antd";
import { DatePickerProps, RangePickerProps } from "./type";
const { RangePicker } = DatePicker;
function AntDatePicker(props:DatePickerProps) {
  return <DatePicker {...props} />;
}

function AntRangePicker(props:RangePickerProps) {
  return <RangePicker {...props} />;
}

export { AntDatePicker as DatePicker, AntRangePicker as RangePicker };
